// src/models/landing-page.js
import bankdataservice from '@/services/bankdataservice';

// The LandingPage class returns a clean
// LandingPage object with only the data we need.
export class Bankdata {
  constructor({
    id = null,
    iban = '',
    accountowner = '',
    location = '',
    date = null,
    address = null
  } = {}) {
    this.id = id
    this.iban = iban
    this.accountowner = accountowner
    this.location = location
    this.date = date
    this.address = address
  }
}

// We use an adapter to bring the API response
// from the Contentful API into the correct format
// for our LandingPage class.
//export function responseAdapter({ fields, sys }) {
//  return new Event({ ...fields, ...sys });
//}

export function responseAdapter(response) {

  let out = [];
  if(response == null){
    return out; 
  }
  else if (response.data != null && Array.isArray(response.data.content)) {
    response.data.content.forEach(element => {
      mapAndAdd(out, element)
    });
  }else if(response.data != null){
    mapAndAdd(out, response.data);
    return out[0];
  }else if(response != null){
    mapAndAdd(out, response);
    return out[0];
  }
  return out;
}

function mapAndAdd(out, element){
  out.push(new Bankdata({ ...element }));
}

// We wrap the Contentful API client to format
// the response exactly the way we like it.
export default {
  async update(bankDataId, bankData) {
    return responseAdapter(await bankdataservice.update(bankDataId, bankData));
  },
};
